/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconCampus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconCampus"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 5.995 22.004 12l-9.995 6-4.01-2.408V19H6v-4.608L2.013 12zm0 2.333-6.103 3.67 6.112 3.67L18.118 12z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconCampus;
